import { Link } from "react-router-dom";
import { allArticles } from "@/mocks/articles";

export default function ArticlesSection() {
  return (
    <section className="relative w-full bg-secondary-50 py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10 md:mb-14">
          <div>
            <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-accent-100 rounded-full text-accent-700 text-xs md:text-sm font-medium mb-3">
              <i className="ri-article-line w-4 h-4 flex items-center justify-center"></i>
              <span>Artykuły SEO</span>
            </div>
            <h2 className="font-heading text-2xl sm:text-3xl md:text-4xl font-semibold text-foreground-950 leading-tight">
              Artykuły i poradniki
            </h2>
          </div>
          <p className="text-sm text-foreground-500 max-w-md">
            Poznaj szczegółowe przewodniki i analizy dotyczące USFansSpreadsheet
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {allArticles.map((article) => (
            <Link
              key={article.id}
              to={`/artykul/${article.slug}`}
              className="cursor-pointer group bg-background-50 rounded-2xl overflow-hidden border border-background-200 hover:border-background-300 transition-all flex flex-col"
            >
              <div className="w-full h-44 md:h-48 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-4 md:p-5 flex flex-col flex-1">
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed mb-4 flex-1 line-clamp-2">
                  {article.excerpt}
                </p>
                <span className="inline-flex items-center gap-1 text-xs md:text-sm font-medium text-primary-600 mt-auto">
                  Czytaj więcej
                  <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center group-hover:translate-x-1 transition-transform"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}